import * as React from "react";

export class HeadingName extends React.PureComponent<{
    name: string
}, {}>{
    render() {
        return (
            <div key={`k_${name}`} className="rj-ev-list__heading-name" data-uat="div-ev-list-heading-name">{this.props.name}</div>
        )
    }
}